import React, {useEffect, useRef, useState} from 'react';
import {Column} from "primereact/column";
import {UsePermissions} from "../../../hooks/usePermissions";

import {getData} from "../../../api/asociado.service";
import {Toast} from 'primereact/toast';
import {DataTable} from 'primereact/datatable';

import {exportExcel} from "../../../shared/utils/utils";
import {Dropdown} from "primereact/dropdown";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import PropTypes from 'prop-types';
import {ContainerTitleTable} from "../../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../../components/Containers/ContainerTable";

export const TableAsociados = ({obtenerParametrosUser, nuevoUsuario, reload}) => {
    const [permisos] = UsePermissions()
    // parametros de la tabla
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [rowInit, setrowInit] = useState(50);
    const [asociado, setAsociado] = useState([])
    // seleccionador
    //  const [selectedProduct5, setSelectedProduct5] = useState(null);

    const toast = useRef(null);


    // payload al backend

    const initParams = {
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: null,
        filters: {
            'asociado_id': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'tipo_doc': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'num_doc': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'nombres': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'apellidos': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'email': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'afp': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'eps': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'pensionado': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'banco': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'tipocuenta': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'num_cuenta': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'estado': {operator: FilterOperator.OR, constraints: [{value: '', matchMode: FilterMatchMode.EQUALS}]},
        }
    };
    const [lazyParams, setLazyParams] = useState(initParams);


    const loadLazyData = () => {
        setLoading(true);
        init({lazyEvent: lazyParams}).then(data => {
            // record
            setTotalRecords(data.total);
            // total
            setAsociado(data.record);
            setLoading(false);
        })

    }


    async function init(datos) {
        const response = await getData(datos);
        const data = await response.data;
        return data.data;
    }

    const onPage = (event) => {
        setrowInit(event.rows);
        setLazyParams(event);
    }

    const onSort = (event) => {
        setLazyParams(event);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    const laziParamsInit = () => {
        setLazyParams(initParams);
    }
    useEffect(() => {
        loadLazyData();

        return () => {
            setTotalRecords(0);
            // total
            setAsociado([]);
        }
    }, [lazyParams])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (reload) {
            loadLazyData();
        }
        return () => {
        }

    }, [reload])

    const actionTemplate = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">

                <button
                    disabled={(!permisos.editar)}
                    className="btn primary-color-btn"
                    type="button"
                    onClick={() => obtenerParametrosUser(rowData)}>
                    <i className="fa fa-user-edit"/>
                </button>
            </div>
        );
    }

    const header = (
        <div className="flex align-items-center justify-between">
            <div>

                <button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.adicionar)}
                    onClick={nuevoUsuario}
                >
                    <i className="fa fa-user"/>
                </button>

            </div>
            <div>
                <button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.consultar)}
                    onClick={loadLazyData}
                >
                    <i className="fa fa-search"/>
                </button>

                <button
                    onClick={laziParamsInit}
                    disabled={(!permisos.consultar)}
                    className="secundary-color-btn btn"
                    type="button"
                >
                    <i className="fa fa-filter"/>
                </button>
                <button
                    onClick={() => exportExcel(asociado, "afiliado")}
                    disabled={(!permisos.consultar)}
                    className="secundary-color-btn btn"
                    type="button"
                >
                    <i className="fa fa-print"/>
                </button>
            </div>

        </div>
    );

    const statuses = [
        {
            name: "Activo",
            value: "A"
        },
        {
            name: "Inactivo",
            value: "I"
        }
    ];



    const statusItemTemplate = (option) => {
        return <span className={`customer-badge status-${option.value}`}>{option.name}</span>;
    }

    const statusFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={statuses}
                         onChange={(e) => options.filterCallback(e.value, options.index)}
                         optionLabel="name"
                         itemTemplate={statusItemTemplate}
                         placeholder="Select a Status" className="p-column-filter"
                         showClear/>;
    }

    return (
        <>
            <Toast ref={toast}/>
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>
            <ContainerTable>
                <DataTable
                    showGridlines
                    header={header}
                    resizableColumns
                    columnResizeMode="expand"
                    size="small"
                    value={asociado}
                    lazy
                    filterDisplay="menu"
                    first={lazyParams.first}
                    totalRecords={totalRecords}
                    onPage={onPage}
                    onSort={onSort}
                    sortField={lazyParams.sortField}
                    sortOrder={lazyParams.sortOrder}
                    onFilter={onFilter}
                    filters={lazyParams.filters}
                    loading={loading}
                    paginator
                    scrollable
                    scrollHeight="500px"
                    rows={rowInit}
                    rowsPerPageOptions={[50, 100, 300, 500]}

                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} afiliados"
                    responsiveLayout="scroll">
                     <Column header="Editar" style={{fontSize: ".8em"}} body={actionTemplate}></Column>

                    <Column hidden field="cliente_id" header="Id" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>

                    <Column field="tipo_doc" header="Tipo doc" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="num_doc" header="Num doc" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="apellidos" header="Apellidos" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="nombres" header="Nombres" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="email" header="Email" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="afp" header="Afp" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="eps" header="Eps" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="pensionado" header="Pensionado" sortable filter
                            showFilterMatchModes={false} onFilterClear={laziParamsInit}></Column>
                    <Column field="banco" header="Banco" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="tipocuenta" header="Tipo cuenta" sortable filter
                            showFilterMatchModes={false} onFilterClear={laziParamsInit}></Column>
                    <Column field="num_cuenta" header="Num cuenta" sortable filter
                            showFilterMatchModes={false} onFilterClear={laziParamsInit}></Column>
                    <Column field="estado" header="Estado" sortable filter
                            filterElement={statusFilterTemplate} showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                </DataTable>
            </ContainerTable>
        </>
    );
};

TableAsociados.prototype = {
    obtenerParametrosUser: PropTypes.func,
    nuevoUsuario: PropTypes.func
}

TableAsociados.defaultProps = {
    reload: false
}
